import React from "react";
import { Card } from "antd";
import {
  DollarOutlined,
  BankOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import { TILE } from "../dashboardTheme";

const COLORS = {
  cash: TILE.profit,
  bank: TILE.sales,
  receivable: TILE.renewals,
  payable: TILE.overdue,
};

const money = (v) => Number(v || 0).toFixed(2);

// Share of a two-part bar. Negative balances (e.g. an overdrawn bank) count as
// zero width, but their figure is still shown as-is in the row.
const split = (a, b) => {
  const x = Math.max(Number(a) || 0, 0);
  const y = Math.max(Number(b) || 0, 0);
  const total = x + y;
  return total ? [(x / total) * 100, (y / total) * 100] : null;
};

const Row = ({ icon, color, name, value, currency }) => (
  <li>
    <span className="erp-bs-badge" style={{ "--kpi-accent": color }}>{icon}</span>
    <span className="erp-bs-name">{name}</span>
    <span className="erp-bs-amount" title={`${money(value)} ${currency || ""}`}>
      {money(value)}
      <span className="erp-unit">{currency}</span>
    </span>
  </li>
);

const Bar = ({ parts, colors }) => (
  <div className="erp-bs-bar" aria-hidden="true">
    {parts ? (
      <>
        <span style={{ flexGrow: parts[0], background: colors[0] }} />
        <span style={{ flexGrow: parts[1], background: colors[1] }} />
      </>
    ) : (
      <span style={{ flexGrow: 1, background: "var(--erp-track)" }} />
    )}
  </div>
);

const BalanceSummary = ({ cash, bank, receivables, payables, currency }) => {
  return (
    <Card className="erp-card erp-bs" variant="borderless">
      <div className="erp-card-head">
        <div>
          <div className="erp-card-title">Balance Summary</div>
          <div className="erp-card-sub">Current balances</div>
        </div>
      </div>

      {/* Cash vs bank */}
      <div className="erp-bs-section">
        <ul className="erp-bs-rows">
          <Row icon={<DollarOutlined />} color={COLORS.cash} name="Cash Balance" value={cash} currency={currency} />
          <Row icon={<BankOutlined />} color={COLORS.bank} name="Bank Balance" value={bank} currency={currency} />
        </ul>
        <Bar parts={split(cash, bank)} colors={[COLORS.cash, COLORS.bank]} />
      </div>

      {/* Money owed to us vs money we owe */}
      <div className="erp-bs-section">
        <ul className="erp-bs-rows">
          <Row icon={<ArrowDownOutlined />} color={COLORS.receivable} name="Receivables" value={receivables} currency={currency} />
          <Row icon={<ArrowUpOutlined />} color={COLORS.payable} name="Payables" value={payables} currency={currency} />
        </ul>
        <Bar parts={split(receivables, payables)} colors={[COLORS.receivable, COLORS.payable]} />
      </div>
    </Card>
  );
};

export default BalanceSummary;
